import React from 'react';
import { get, zipObject, cloneDeep } from '../../../utils/lodash';

import { Table, TableBody, ButtonBase, Button } from '@mui/material';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

import TrplFormRow from '../TrplFormRow';

import Loader from '../../Loader';
import Accordeon from '../../Accordeon';
import ArrowTooltipCss from '../../ArrowTooltipCss';
import MandatoryAlertIcon from './MandatoryAlertIcon';
import TrplSelect from '../../TrplControls/TrplSelect';
import { prdcParamsForm } from '../../../utils';
export default class AccordeonNode extends React.Component {
  render() {
    const {
      rst,
      frm,
      trpl,
      data,
      mode,
      formId,
      classes,
      setTrpl,
      trplOid,
      groupId,
      accIndex,
      isOpened,
      trplIndex,
      isNewNode,
      accFrmEdit,
      getTrplNode,
      mainConcept,
      hideOpenBtn,
      saveOnlyForm,
      submitOnlyForm,
      getRstMetaData,
      optionalFields,
      onRstValueEdit,
      toggleAccordeon,
      removeTrplValue,
      showOptionalRst,
      getRstTrplsData,
      onNodeRemoveClick,
      onRstTypeBtnClick,
      formConceptsByKeys,
      isDeleteBtnLoading,
      setDeleteBtnLoading,
      openObjectEditModal,
      removeAccordeonNode,
      hideAddAndDeleteBtns,
      onAccordeonEditClick,
      getAutocompleteTrpls,
      isDisableTrplEditing,
      toggleUploadImgModal,
      accordeonRestrictions,
      accRequiredFieldsCount,
      onChangeTextereaHeight,
      updateDataOnRestoreTrpl,
      openTrplRenderPartsModal,
      onAccordeonAddNewNodeClick,
      onWidgetCheckboxesValueEdit,
      onNodeAddDropdownElementClick,
    } = this.props;

    let optionalFieldsOptions = [];

    const optionalFieldsRstrs = get(optionalFields, [groupId, trplOid, 'restrictions']);

    if (optionalFieldsRstrs) {
      Object.keys(optionalFieldsRstrs).forEach((itemKey) => {
        const item = optionalFieldsRstrs[itemKey];

        if (item && !item.show)
          optionalFieldsOptions.push({
            title: item.title,
            value: item.id,
          });
      });
    }

    const accordeonTitle = (trplIndex || trplIndex === 0) ? `${trplIndex + 1} ${data.nodes[trplOid] ? data.nodes[trplOid].title : ''}`
      : `${data.nodes[trplOid] ? data.nodes[trplOid].title : ''}`;

    return (
      <Accordeon
        isOpened={isOpened}
        titleLeftCol={accRequiredFieldsCount ? <MandatoryAlertIcon tooltipText={'Includes mandatory fields'}/> : null}
        toggleAccordeon={() => toggleAccordeon(accIndex, !isOpened)}
        title={accordeonTitle}
        titleRightCol={
          <div className={classes.flex}>
            <React.Fragment>
              {accFrmEdit && !isNewNode && !hideOpenBtn &&
                <ButtonBase
                  size="small"
                  className={`${classes.mr10} ${classes.btn} ${classes.btnEmpty}`}
                  style={{
                    borderRadius: '15px',
                    textTransform: 'capitalize',
                  }}
                  classes={{
                    disabled: classes.btnNormalDisabled,
                    focusVisible: classes.focusable,
                  }}
                  onClick={() => {
                    if (accFrmEdit) {
                      openObjectEditModal('edit', trplOid, rst, accFrmEdit.id)
                    } else {
                      onAccordeonEditClick(trplOid, rst)
                    }
                  }}
                >
                  Open
                </ButtonBase>
              }

              {hideAddAndDeleteBtns ? null
              : rst ? (isDeleteBtnLoading.isLoading && isDeleteBtnLoading.index === trplIndex ? (
                <div
                  style={{ width: '69px', alignItems: 'center' }}
                  className={`${classes.mr10} ${classes.justifyCenter}`}
                >
                  <Loader style={{ zoom: '0.7' }} />
                </div>
              ) : (
                <ArrowTooltipCss text={`Delete "${accordeonTitle}"?`} placement="right" style={{ position: 'relative' }}>
                  <Button
                    size="small"
                    className={`${classes.trplBtn} ${classes.howerRedColor} delete_btn`}
                    style={{ minWidth: '24px', borderRadius: '20px', height: '24px', width: '24px', padding: 0, backgroundImage: 'none', '&:hover': { color: 'red' } }}
                    onClick={() => {
                      setDeleteBtnLoading({
                        isLoading: true,
                        index: trplIndex,
                      });

                      removeAccordeonNode(trpl.tid, trplOid, trpl.pid, trplIndex, mainConcept, () => {
                        setDeleteBtnLoading({
                          isLoading: false,
                          index: null,
                        });
                      });
                    }}
                  >
                    <DeleteOutlineOutlinedIcon className={`${classes.howerRedColor}`} style={{ fontSize: 13, color: 'inherit' }}/>
                  </Button>
                </ArrowTooltipCss>
              )) : null}
            </React.Fragment>
          </div>
        }
      >
        <Table className={classes.fw}>
          <TableBody>
          {!frm && accordeonRestrictions[rst || mainConcept] ? accordeonRestrictions[rst ? rst : mainConcept].map((rst, rstIndex) => {
              if (Array.isArray(rst)) rst = zipObject(prdcParamsForm, rst);
              const itemRst = getRstTrplsData(null, rst, trplOid, rst.sid, this.props.rst, accIndex);

              return (
                <TrplFormRow
                  rst={rst}
                  data={data}
                  isGroup={true}
                  key={rstIndex}
                  formId={formId}
                  groupId={groupId}
                  classes={classes}
                  rstData={itemRst}
                  setTrpl={setTrpl}
                  isAnotherNode={true}
                  isNewNode={isNewNode}
                  ancestorId={trplOid}
                  saveOnlyForm={saveOnlyForm}
                  submitOnlyForm={submitOnlyForm}
                  getRstMetaData={getRstMetaData}
                  onRstValueEdit={onRstValueEdit}
                  getRstTrplsData={getRstTrplsData}
                  removeTrplValue={removeTrplValue}
                  onRstTypeBtnClick={onRstTypeBtnClick}
                  onNodeRemoveClick={onNodeRemoveClick}
                  openObjectEditModal={openObjectEditModal}
                  toggleUploadImgModal={toggleUploadImgModal}
                  getAutocompleteTrpls={getAutocompleteTrpls}
                  isDisableTrplEditing={isDisableTrplEditing}
                  onChangeTextereaHeight={onChangeTextereaHeight}
                  updateDataOnRestoreTrpl={updateDataOnRestoreTrpl}
                  openTrplRenderPartsModal={openTrplRenderPartsModal}
                  onWidgetCheckboxesValueEdit={onWidgetCheckboxesValueEdit}
                  onNodeAddDropdownElementClick={onNodeAddDropdownElementClick}
                />
              );
            })
            : frm && frm.groups.length
            ? frm.groups.length && frm.groups[0].map((frmGroup) => {
                return frmGroup.items.map((item, itemIndex) => {
                  if (!accordeonRestrictions[frm.id][item.pid] && !item.hasOwnProperty("custom_component")) return null;

                  const itemConceptKey = item.concept_key ? item.concept_key : 'concept';
                  const parentConcept = formConceptsByKeys && formConceptsByKeys[itemConceptKey] ? formConceptsByKeys[itemConceptKey] : frm.concept;

                  const itemRst = item.hasOwnProperty("custom_component") ? null
                    : getRstTrplsData(item, accordeonRestrictions[frm.id][item.pid], trplOid, parentConcept, rst, accIndex);

                  if (itemRst) {
                    if (
                      !itemRst.trpl &&
                      optionalFieldsRstrs &&
                      optionalFieldsRstrs[item.pid] &&
                      !optionalFieldsRstrs[item.pid].show
                    )
                      return null;

                    if (optionalFieldsRstrs && optionalFieldsRstrs[item.pid]) {
                      const findedOptionIndex = optionalFieldsOptions.findIndex((option) => +option.value === +item.pid);

                      if (findedOptionIndex !== -1) optionalFieldsOptions.splice(findedOptionIndex, 1);
                    }
                  }

                  const itemIdentificator = itemRst ? item.pid : item.id;

                  const fullRst = cloneDeep(accordeonRestrictions[frm.id][itemIdentificator]);
                  if (rst) fullRst.accordeonInfo = { rstId: rst, index: trplIndex, concept: frm.concept, accIndex };

                  return (
                    <TrplFormRow
                      mode={mode}
                      rst={fullRst}
                      frm={frm}
                      data={data}
                      item={item}
                      isGroup={true}
                      key={itemIndex}
                      formId={formId}
                      classes={classes}
                      groupId={groupId}
                      rstData={itemRst}
                      setTrpl={setTrpl}
                      isAnotherNode={true}
                      ancestorId={trplOid}
                      isNewNode={isNewNode}
                      getTrplNode={getTrplNode}
                      saveOnlyForm={saveOnlyForm}
                      submitOnlyForm={submitOnlyForm}
                      getRstMetaData={getRstMetaData}
                      onRstValueEdit={onRstValueEdit}
                      getRstTrplsData={getRstTrplsData}
                      removeTrplValue={removeTrplValue}
                      accordeonData={fullRst.accordeonInfo}
                      onRstTypeBtnClick={onRstTypeBtnClick}
                      onNodeRemoveClick={onNodeRemoveClick}
                      removeAccordeonNode={removeAccordeonNode}
                      openObjectEditModal={openObjectEditModal}
                      isDisableTrplEditing={isDisableTrplEditing}
                      toggleUploadImgModal={toggleUploadImgModal}
                      getAutocompleteTrpls={getAutocompleteTrpls}
                      onChangeTextereaHeight={onChangeTextereaHeight}
                      updateDataOnRestoreTrpl={updateDataOnRestoreTrpl}
                      openTrplRenderPartsModal={openTrplRenderPartsModal}
                      onAccordeonAddNewNodeClick={onAccordeonAddNewNodeClick}
                      onWidgetCheckboxesValueEdit={onWidgetCheckboxesValueEdit}
                      onNodeAddDropdownElementClick={onNodeAddDropdownElementClick}
                    />
                  );
                });
              })
            : null}

          {optionalFields[groupId] && optionalFieldsOptions.length ? (
            <div
              style={{
                width: '130px',
                padding: '5px 10px 10px 10px',
              }}
            >
              <TrplSelect
                margin="none"
                complicatedValues
                placeholder="Optional"
                disalbeItalicPlaceholder
                values={optionalFieldsOptions}
                value={optionalFields[groupId][trplOid].selectValue}
                onChange={(e) => {
                  showOptionalRst(e.target.value, groupId, trplOid);
                }}
              />
            </div>
          ) : null}
          </TableBody>
        </Table>
      </Accordeon>
    );
  }
}
